<template>
  <section>
    <div class="tip" style="margin:0 0 0 20px">* 项目基本资料</div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="承包单位">
          <el-input size="small" :disabled="true" placeholder="请输入承包单位" v-model="form.cbdw"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="合同号">
          <el-input size="small" :disabled="true" v-model="form.htbh"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="监理单位">
          <el-input size="small" placeholder="请输入承包单位" v-model="form.jldw"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="编号">
          <el-input size="small" v-model="form.bh"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目名称">
          <el-input size="small" v-model="project.name" placeholder="请输入项目名称"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="变更部位">
          <el-input size="small" v-model="form.bgbw" placeholder="请输入变更部位"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item label="表单类型">
      <el-radio v-model="form.type" label="0">工程技术联系单</el-radio>
      <el-radio v-model="form.type" label="1">工程洽商记录</el-radio>
    </el-form-item>

    <div class="clear" v-if="form.type == '0'">
      <el-col :span="12">
        <el-form-item label="原设计图名称">
          <el-input size="small" v-model="form.ysjtmc" placeholder="请输入原设计图名称"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="图号">
          <el-input size="small" v-model="form.th" placeholder="请输入图号"></el-input>
        </el-form-item>
      </el-col>
    </div>

    <el-form-item label="原因及内容">
      <el-input type="textarea" placeholder="请输入原因及内容" :autosize="{ minRows: 3, maxRows: 6}" size="small" v-model="form.content"></el-input>
    </el-form-item>

    <div class="clear">
      <el-col :span="12">
        <el-form-item label="报告人">
          <el-input size="small" v-model="form.bgr"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="报告日期">
          <el-date-picker v-model="form.bgrq" size="small" value-format="yyyy-MM-dd" type="date" placeholder="选择申请印章的时间">
          </el-date-picker>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="合同金额">
          <el-input size="small" v-model="form.htje"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="合同工期">
          <el-input size="small" v-model="form.htgq"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="变更金额">
          <el-input size="small" v-model="form.bgje"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="延长工期">
          <el-input size="small" v-model="form.ycgq"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item label="变更类型">
      <el-select v-model="form.bgjelx" style="width:600px" placeholder="请选择">
        <el-option v-for="item in bglxArr" :key="item.type" :label="item.title" :value="item.type">
        </el-option>
      </el-select>
    </el-form-item>
  </section>
</template>

<script>
  export default {
    props: ['project', 'formByFather', 'userData'],
    data() {
      return {
        form: {},
        bglxArr: [{
          type: 0,
          title: "变更金额不大于1元，且增加造价占合同价10%以内"
        }, {
          type: 1,
          title: "变更金额1-5元，且增加造价占合同价10%以内"
        }, {
          type: 2,
          title: "变更金额5-20元，且增加造价占合同价10%以内"
        }, {
          type: 3,
          title: "变更金额大于20元，或增加造价占合同比例大于10%"
        }],
      }
    },
    mounted() {
      this.form = this.formByFather
    },
    methods: {
      getFromData() {
        return this.form
      }
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/createTechContact.vue